export function getPreviewStyle(welcomeSign) {
    if (welcomeSign.rotation !== 0) {
        if (welcomeSign.rotation < 0) {
            return {
                width: '100%',
                marginBottom: '30%',
                transform: `rotate(${welcomeSign.rotation}deg) translate(-100%)`,
                transformOrigin: 'top left',
            };
        }

        if (welcomeSign.rotation > 0) {
            return {
                width: '100%',
                marginBottom: '30%',
                transform: `rotate(${welcomeSign.rotation}deg) translate(0, -100%)`,
                transformOrigin: 'top left',
            };
        }
    }

    return {
        width: '100%',
    };
}
